import {
  shape,
  string,
  bool,
} from 'prop-types';

const bounceRebookedActivityShape = shape({
  note: string,
  loadId: string,
  carrierName: string,
  initiatorName: string,
  eventId: string,
  eventTime: string,
  eventType: string,
  isAutomated: bool,
  isLiveBounce: bool,
  reason: string,
});

export default bounceRebookedActivityShape;
